import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

/**
 * ImageUpload: uploads to /api/upload (returns {id, url}) and stores the absolute URL.
 * url stored is the absolute backend URL so img tags display directly.
 */
export default function ImageUpload({ value, onChange, label = "Imagem", testid = "image-upload" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const choose = () => ref.current?.click();

  const upload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Selecione uma imagem"); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error("Imagem muito grande (max 10MB)"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Imagem enviada!");
    } catch (e) {
      toast.error("Erro no upload");
    } finally {
      setBusy(false);
    }
  };

  const onPick = (e) => {
    const f = e.target.files?.[0];
    upload(f);
    e.target.value = "";
  };

  return (
    <div data-testid={testid}>
      <input type="file" accept="image/*" ref={ref} onChange={onPick} className="hidden" />
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="" className="w-full max-w-md border border-zinc-300" />
          <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 bg-black/70 text-white p-1 hover:bg-red-700" data-testid={`${testid}-clear`}>
            <X size={14}/>
          </button>
        </div>
      ) : null}
      <div className="flex items-center gap-2 mt-2">
        <button type="button" onClick={choose} disabled={busy} className="flex items-center gap-2 border border-zinc-400 px-3 py-2 font-sans-ui text-xs uppercase tracking-widest font-semibold hover:bg-zinc-100 disabled:opacity-50" data-testid={`${testid}-btn`}>
          {busy ? <Loader2 className="animate-spin" size={14}/> : <Upload size={14}/>}
          {busy ? "Enviando..." : (value ? "Trocar" : "Enviar")} {label}
        </button>
        <span className="font-sans-ui text-xs text-zinc-400">ou cole URL:</span>
        <input
          type="url"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://..."
          className="flex-1 border border-zinc-300 px-2 py-1.5 font-sans-ui text-xs"
          data-testid={`${testid}-url`}
        />
      </div>
    </div>
  );
}
